import { useAppRouterInterface, useAppRouterState } from '@/app/addRouter';
import { PanelLocation } from '@/app/navigation/panel-state-utils';
import { PanelStateAPI } from '@/app/navigation/usePanelState';
import useDeepMemo from '@/hooks/use-deep-memo';
import { createContext, PropsWithChildren } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export const PanelContext = createContext<PanelStateAPI | null>(null);

export function PanelContextProvider({
  children,
  stackIdx,
  panelIdx,
}: PropsWithChildren<{ stackIdx: number; panelIdx: number }>) {
  const appRouterItf = useAppRouterInterface();
  const appRouterState = useAppRouterState();

  const panelState = appRouterState.panelState[stackIdx]?.[panelIdx] || {};

  const api = useDeepMemo<PanelStateAPI>(() => {
    const loc: PanelLocation = { panel: panelIdx, stack: stackIdx };
    return {
      clearState() {
        appRouterItf.clearPanelState(loc);
      },
      setState(stateOrFunc) {
        appRouterItf.setPanelState(loc, stateOrFunc);
      },
      state: panelState,
    };
  }, [panelState]);

  return <PanelContext.Provider value={api}>{children}</PanelContext.Provider>;
}
